import client from "@irati/utils/services/apollo"
import PBService from "@irati/utils/services"

import generateAssertion, {generateAssertionKey} from "./queries/generateAssertion"
import authErrorHandler from "./errors/authErrorHandler"

class Assertions extends PBService {
  async generateAssertion(variables: any): Promise<any> {
    const {data} = await client.query({query: generateAssertion, variables, fetchPolicy: "no-cache"})
    return data[generateAssertionKey]
  }
}

const MagicLoginService = new Assertions({errorHandlers: [authErrorHandler]})

export default MagicLoginService
